import React, {useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import styled from 'styled-components';
import {analyticsTrackState} from '../../helpers/Analytics';

export default function AgeSetComplete({onClose}) {
    const {t} = useTranslation();

    useEffect(() => {
        analyticsTrackState('preferencesset');
    }, []);

    return (
        <Container>
            <Content>
                <Title>{t('ageRating.titleSuccess1')}</Title>
                <BorderedTitle>{t('ageRating.titleSuccess2')}</BorderedTitle>
                <MainImage />
                <span>{t('ageRating.subtitleSuccess')}</span>
                <ConfirmButton onClick={onClose}>
                    {t('ageRating.ctaSuccess')}
                </ConfirmButton>
            </Content>
        </Container>
    );
}

const Container = styled.div`
    width: 311px;
    background-color: #363036;
    display: flex;
    flex-direction: column;
`;

const Content = styled.div`
    display: flex;
    flex: 1;
    margin: 15px;
    flex-direction: column;

    span {
        text-align: center;
        margin: 24px 0px;
    }
`;

const Title = styled.div`
    font-family: TTNormsProExtraBlack;
    font-size: 32px;
    color: white;
    margin: 20px 0px 0px 20px;
    text-transform: uppercase;
`;

const BorderedTitle = styled.div`
    font-family: TTNormsProExtraBlack;
    font-size: 32px;
    height: 900;
    text-shadow: 1px 1px 0 white, -1px 1px 0 white, 1px -1px 0 white,
        -1px -1px 0 white;
    color: #211921;
    text-transform: uppercase;
    margin: 0px 0px 0px 20px;
`;

const MainImage = styled.img.attrs({
    src: require('../../assets/ill_age_set.png'),
})`
    align-self: flex-end;
    height: 163px;
`;

const ConfirmButton = styled.div`
    display: flex;
    height: 45px;
    align-items: center;
    justify-content: center;
    background: linear-gradient(90deg, #f55a86 0%, #ec098c 100%);
    border-radius: 6px;
    text-transform: uppercase;
    font-family: TTNormsProExtraBlack;
    font-size: 20px;
    padding: 0px 20px;
    path {
        fill: #fff;
    }
    cursor: pointer;
`;
